import axios from 'axios';
import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   show: false
};

// getters
const getters = {
};

// actions
const actions = {
   MESSAGE_SHOW: function(context, {show}){
      context.commit('MESSAGE_SHOW',{show});
   },
   MESSAGE_SEND: async function(context, {body, email, currentUrl, subject}){
      try {
         const res = await api.post('/api/contact-requests',{
            body,
            email: email || null,
            currentUrl,
            subject,
         })
      } catch(e){
         context.commit('ERROR_MESSAGE_SET',{message:'message failed'});
         throw new Error('message failed')
      }
   },
};

// mutations
const mutations = {
   MESSAGE_SHOW:(state, {show})=>{
      state.show = show;
   },
};

export default {
   state,
   getters,
   actions,
   mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/message.js